/* eslint-disable max-len, padded-blocks */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import {
  Store, set, get,
} from 'idb-keyval';
import api from '@/api';

export const namespaced = true;

function initialInvasive() {
  return {
    present: false,
    percentOfInfestation: null,
    infestationSize: null,
    notes: null,
  };
}
function emptyGeneralDetails() {
  return {
    relatedContacts: [],
    visitedBy: null,
    dateOfVisit: null,
    otherPartiesPresent: null,
    operatorHasKnowledgeOfTheProject: null,
    landownerPreferredFormOfContact: null,
    landownerResourcePriorities: [],
    landownerGoals: null,
    enrollmentInOtherPrograms: null,
    comfortableWithHerbicideUse: null,
    primaryLandUse: null,
    secondaryLandUse: null,
    propertyWaterFeatures: null,
    waterRights: null,
    otherEasements: null,
    notes: null,
  };
}
function emptyPropertyAccess() {
  return {
    trespassingIssues: 'None',
    typesOfShootingHunting: 'None',
    describePotentialHazards: null,
    adjacentPropertiesUnderConservation: null,
    neighborInterestInConservationProjectEnrollment: null,
    dogsOnSite: null,
    dogSafetyMeasures: [],
    notes: null,
  };
}
function emptyInvasives() {
  return {
    reedCanarygrass: initialInvasive(),
    nonNativeBlackberries: initialInvasive(),
    scotchBroom: initialInvasive(),
    englishIvy: initialInvasive(),
    garlicMustard: initialInvasive(),
    purpleLoosestrife: initialInvasive(),
    knotweed: initialInvasive(),
    spurgeLaurel: initialInvasive(),
    falseBrome: initialInvasive(),
    giantHogweed: initialInvasive(),
    poisonOak: initialInvasive(),
    lesserCelandine: initialInvasive(),
    italianArum: initialInvasive(),
    edrrSpeciesNotListed: initialInvasive(),
  };
}
function emptyAgriculturalDetails() {
  return {
    farmedLessThanTenYears: null,
    agriculturalManagementGoals: [],
    otherAgriculturalManagementGoals: null,
    cropsBeingGrown: [],
    farmingMethod: null,
    irrigationMethods: [],
    irrigationEfficienciesInterest: null,
    fertilizerScheduleDescription: null,
    fertilizerTypeDescription: null,
    manureManagementDescription: null,
    livestockRaisedOnSiteCattle: null,
    livestockRaisedOnSiteHorses: null,
    livestockRaisedOnSiteChickens: null,
    livestockRaisedOnSiteSheep: null,
    livestockRaisedOnSiteTurkeys: null,
    livestockRaisedOnSiteGoats: null,
    livestockRaisedOnSiteAlpacas: null,
    livestockRaisedOnSiteOther: null,
    timeSeasonInPasture: null,
    livestockOffChannelWatering: null,
    notes: null,
  };
}
function emptyForestDetails() {
  return {
    stewardshipPlanExists: null,
    stewardshipPlanInterest: null,
    primaryGoals: [],
    otherGoals: null,
    forestConcerns: [],
    otherConcerns: null,
    acresOfForest: null,
    primaryTreeSpecies: [],
    notes: null,
  };
}
function emptyStreamsDetails() {
  return {
    fencingNeeded: null,
    predationIssues: null,
    floodingRegime: null,
    crossingAvailable: null,
    names: null,
    typesOfStreams: [],
    potentialBufferWidth: null,
    existingShade: null,
    artificalModifications: [],
    streamBankConditions: [],
    channelObservations: [],
    visiblePassageBarriers: null,
    dominantSubstrate: [],
    naturalProcesses: null,
    notes: null,
  };
}
function emptyHabitatDetails() {
  return {
    conservationgoals: [],
    currentSiteManagement: null,
    nativeRiparianSpp: [],
    historicPlantType: [],
    historicPlantCondition: null,
    forestStands: null,
    historicHydrology: [],
    targetWeedSpp: null,
    wildlifeObservations: null,
    wildlifeConcerns: [],
    beaverInfluence: null,
    equipmentDebris: null,
    siteAccessibility: null,
    notes: null,
  };
}
function emptyUrbanDetails() {
  return {
    siteType: null,
    briefHistory: null,
    primaryGoals: [],
    otherConcerns: null,
    treeHealthConcerns: [],
    bhcp: null,
    professionalPlan: null,
    landownerTenantPreference: [],
    waterConservationPractices: [],
    stormwaterPractices: [],
    floodingConcerns: [],
    floodingSteps: [],
    nativeSpp: null,
    notes: null,
  };
}
function emptyTechnicalDetails() {
  return {
    nextSteps: null,
    dateOfVisit: new Date(Date.now() + (3600 * 1000 * 24)),
    furtherAssistance: [],
    referrals: [],
    notes: null,
  };
}
function emptySiteVisit() {
  return {
    generalDetails: emptyGeneralDetails(),
    propertyAccess: emptyPropertyAccess(),
    invasiveSpeciesDetails: emptyInvasives(),
    agriculturalDetails: emptyAgriculturalDetails(),
    forestDetails: emptyForestDetails(),
    streamsDetails: emptyStreamsDetails(),
    habitatDetails: emptyHabitatDetails(),
    urbanDetails: emptyUrbanDetails(),
    technicalDetails: emptyTechnicalDetails(),
  };
}
function defaultNAString(value) {
  return value || 'N/A';
}
function initializeSiteVisitFromSite(currentSite, currentUser) {
  console.debug('Enter initializeSiteVisitFromSite()');

  const siteVisit = emptySiteVisit();
  siteVisit.siteId = currentSite.Id;
  siteVisit.localCreatedAt = new Date();
  siteVisit.generalDetails.siteName = currentSite.RecordName;

  let primaryContacts = currentSite.contacts.filter((contact) => contact.Primary__c === true);
  primaryContacts = primaryContacts.sort((a, b) => {
    if (a.FIRST_NAME > b.FIRST_NAME) {
      return 1;
    }
    return -1;
  });

  let nonprimaryContacts = currentSite.contacts.filter((contact) => contact.Primary__c !== true);
  nonprimaryContacts = nonprimaryContacts.sort((a, b) => {
    if (a.FIRST_NAME > b.FIRST_NAME) {
      return 1;
    }
    return -1;
  });

  const relatedContacts = primaryContacts.concat(nonprimaryContacts);

  siteVisit.generalDetails.relatedContacts = relatedContacts.map((contact) => `${contact.FIRST_NAME} ${contact.LAST_NAME}, ${defaultNAString(contact.Role__c)}${contact.Primary__c ? ' (Primary)' : ''}`);
  siteVisit.generalDetails.visitedBy = currentUser;
  siteVisit.generalDetails.dateOfVisit = new Date();

  console.debug('Exit initializeSiteVisitFromSite()');
  return siteVisit;
}
function getInvasiveSpecies() {
  return {
    legend: 'Invasives',
    headerName: 'Invasive Species',
    fields: [
      {
        name: 'Reed Canarygrass',
        field: 'reedCanarygrass',
      },
      {
        name: 'Non-Native Blackberries',
        field: 'nonNativeBlackberries',
      },
      {
        name: 'Scotch Broom',
        field: 'scotchBroom',
      },
      {
        name: 'English Ivy',
        field: 'englishIvy',
      },
      {
        name: 'Garlic Mustard',
        field: 'garlicMustard',
      },
      {
        name: 'Purple Loosestrife',
        field: 'purpleLoosestrife',
      },
      {
        name: 'Knotweed',
        field: 'knotweed',
      },
      {
        name: 'Spurge Laurel',
        field: 'spurgeLaurel',
      },
      {
        name: 'False Brome',
        field: 'falseBrome',
      },
      {
        name: 'Giant Hogweed',
        field: 'giantHogweed',
      },
      {
        name: 'Poison Oak',
        field: 'poisonOak',
      },
      {
        name: 'Lesser Celandine',
        field: 'lesserCelandine',
      },
      {
        name: 'Italian Arum',
        field: 'italianArum',
      },
      {
        name: 'Invasive Species Not Listed',
        field: 'edrrSpeciesNotListed',
      },
    ],
  };
}

export const state = {
  siteVisit: null,
  serverSiteVisit: null,
  showErrorsOnActiveTab: false,
  submitSuccess: false,
  invasives: getInvasiveSpecies(),
};

export const actions = {
  async postSiteVisit({ commit, dispatch }, siteVisit) {
    await api.post('/sitevisit/', siteVisit).then((response) => {
      commit('SET_SITE_VISIT', response.data);
      dispatch('persistCurrentSiteVisit');
    });
  },
  setSubmitSuccess({ commit }, value) {
    return commit('SET_SUBMIT_SUCCESS', value);
  },
  clearSiteVisit({ commit }) {
    return commit('CLEAR_SITE_VISIT');
  },
  setShowErrorsOnActiveTab({ commit }, value) {
    return commit('SET_SHOW_ERRORS', value);
  },
  persistCurrentSiteVisit({ state }) {
    // save to idb
    const customStore = new Store('AcornDBSiteVisits', 'siteVisit');
    set(state.siteVisit.siteId, state.siteVisit, customStore);
  },
  async fetchSiteVisit({ commit }, { currentSite, currentUser, initializeVisit }) {
    const customStore = new Store('AcornDBSiteVisits', 'siteVisit');
    commit('SET_SERVER_SITE_VISIT', null);
    await get(currentSite.Id, customStore).then((siteVisit) => {
      if (siteVisit) {
        return api.get(`/sitevisit/${currentSite.Id}`).then(
          (response) => {
            // store serverSiteVisit if our version is different than the local one.
            // this will let us ask if the user wants to overwrite what we have
            if (new Date(response.data.updatedAt).getTime() !== new Date(siteVisit.updatedAt).getTime()) {
              commit('SET_SERVER_SITE_VISIT', response.data);
            }
            commit('SET_SITE_VISIT', siteVisit);
          },
        ).catch(
          () => commit('SET_SITE_VISIT', siteVisit),
        );
      }
      return api.get(`/sitevisit/${currentSite.Id}`).then(
        (response) => commit('SET_SITE_VISIT', response.data),
      ).catch(
        () => {
          if (initializeVisit) {
            return commit('SET_SITE_VISIT', initializeSiteVisitFromSite(currentSite, currentUser));
          }
          return commit('SET_SITE_VISIT', null);
        },
      );
    });
  },
  copyServerSiteVisit({ commit, state, dispatch }) {
    commit('SET_SITE_VISIT', state.serverSiteVisit);
    dispatch('persistCurrentSiteVisit');
    return commit('SET_SERVER_SITE_VISIT', null);
  },
  setSiteVisit({ commit }, siteVisit) {
    return commit('SET_SITE_VISIT', siteVisit);
  },
  setGeneralDetails({ commit }, generalDetails) {
    return commit('SET_GENERAL_DETAILS', generalDetails);
  },
  setPropertyAccess({ commit }, propertyAccess) {
    return commit('SET_PROPERTY_ACCESS', propertyAccess);
  },
  setInvasiveSpeciesDetails({ commit }, invasiveSpeciesDetails) {
    return commit('SET_INVASIVE_SPECIES_DETAILS', invasiveSpeciesDetails);
  },
};

export const mutations = {
  CLEAR_SITE_VISIT(state) {
    state.siteVisit = emptySiteVisit();
  },
  SET_SERVER_SITE_VISIT(state, siteVisit) {
    state.serverSiteVisit = siteVisit;
  },
  SET_SITE_VISIT(state, siteVisit) {
    // this is just some code to clean up any loose ends if some of the child objects are null
    const localSV = siteVisit;
    if (siteVisit !== null) {
      if (siteVisit.agriculturalDetails === null) {
        localSV.agriculturalDetails = emptyAgriculturalDetails();
      }
      if (siteVisit.forestDetails === null) {
        localSV.forestDetails = emptyForestDetails();
      }
      if (siteVisit.generalDetails === null) {
        localSV.generalDetails = emptyGeneralDetails();
      }
      if (siteVisit.habitatDetails === null) {
        localSV.habitatDetails = emptyHabitatDetails();
      }
      if (siteVisit.invasiveSpeciesDetails === null) {
        localSV.invasiveSpeciesDetails = emptyInvasives();
      }
      if (siteVisit.propertyAccess === null) {
        localSV.propertyAccess = emptyPropertyAccess();
      }
      if (siteVisit.streamsDetails === null) {
        localSV.streamsDetails = emptyStreamsDetails();
      }
      if (siteVisit.technicalDetails === null) {
        localSV.technicalDetails = emptyTechnicalDetails();
      }
      if (siteVisit.urbanDetails === null) {
        localSV.urbanDetails = emptyUrbanDetails();
      }
    }
    state.siteVisit = localSV;
  },
  SET_SUBMIT_SUCCESS(state, value) {
    state.submitSuccess = value;
  },
  SET_GENERAL_DETAILS(state, generalDetails) {
    state.siteVisit.generalDetails = generalDetails;
  },
  SET_PROPERTY_ACCESS(state, propertyAccess) {
    state.siteVisit.propertyAccess = propertyAccess;
  },
  SET_INVASIVE_SPECIES_DETAILS(state, invasiveSpeciesDetails) {
    state.siteVisit.invasiveSpeciesDetails = invasiveSpeciesDetails;
  },
  SET_SHOW_ERRORS(state, value) {
    state.showErrorsOnActiveTab = value;
  },
};
